/* NUDDA — interacciones propias */
(function () {
  'use strict';

  /* Aparición progresiva al hacer scroll */
  function initReveal() {
    var items = document.querySelectorAll('.nd-reveal:not(.is-in)');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var delay = parseInt(el.dataset.ndDelay || '0', 10);
          setTimeout(function () { el.classList.add('is-in'); }, delay);
          io.unobserve(el);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.12 }
    );

    items.forEach(function (el) { io.observe(el); });
  }

  /* Marquesina: duplica el contenido para que el bucle no tenga cortes */
  function initMarquee() {
    document.querySelectorAll('.nd-marquee__track:not([data-nd-cloned])').forEach(function (track) {
      track.dataset.ndCloned = 'true';
      track.innerHTML += track.innerHTML;
    });
  }

  /* Acordeón de preguntas frecuentes */
  function initFaq() {
    document.querySelectorAll('.nd-faq__q:not([data-nd-bound])').forEach(function (btn) {
      btn.dataset.ndBound = 'true';
      btn.addEventListener('click', function () {
        var item = btn.closest('.nd-faq__item');
        var panel = item.querySelector('.nd-faq__a');
        var open = item.classList.contains('is-open');

        item.classList.toggle('is-open', !open);
        btn.setAttribute('aria-expanded', String(!open));
        panel.style.maxHeight = open ? null : panel.scrollHeight + 'px';
      });
    });
  }

  function init() {
    initReveal();
    initMarquee();
    initFaq();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* El editor de temas recarga secciones sin recargar la página */
  document.addEventListener('shopify:section:load', init);
})();
